/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Requestcompanionslabel2Inputs */

const en_requestcompanionslabel2 = /** @type {(inputs: Requestcompanionslabel2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Companions: ${i?.count}`)
};

const de_requestcompanionslabel2 = /** @type {(inputs: Requestcompanionslabel2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Begleitung: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Companions: {count}" |
*
* @param {Requestcompanionslabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestcompanionslabel2 = /** @type {((inputs: Requestcompanionslabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestcompanionslabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestcompanionslabel2(inputs)
	return de_requestcompanionslabel2(inputs)
});
export { requestcompanionslabel2 as "requestCompanionsLabel" }